// eslint-disable-next-line import/prefer-default-export
export const RULE_ACTION = {
    SYSTEM: 'SYSTEM',
    CUSTOMER_INPUT:'CUSTOMER_INPUT', // 客户填写
    NONE: 'NONE'
}

// 枚举所有的受控字段（邮件下单规则）
export const RULE_FIELD = {
    EMAIL_CAR_TYPE:'EMAIL_CAR_TYPE',
    EMAIL_PRODUCT_CODE:'EMAIL_PRODUCT_CODE',
    EMAIL_PROJECT_CONDITION:'EMAIL_PROJECT_CONDITION',
    END_STATION:'END_STATION',
    END_TIME:'END_TIME',
    SKU_INFO:'SKU_INFO',
    START_STATION:'START_STATION',
    START_TIME:'START_TIME',
    EMAIL_LINE_REMARK:'EMAIL_LINE_REMARK',
}
